import Vue from 'vue';
import VueRouter from 'vue-router';
// import routes from './routes';
import routes from '../routes.js';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  mode: "history",
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
  beforeEach: (to, from, next) => {
    document.title = to.meta.title;
    next();
  }
});

export default router;
